export default __webpack_public_path__ + "static/media/gatewayIcon.aaf7a847.png";